import Head from "next/head";

//local imports
import TechnologyPartner from "@/components/partners/technology";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Technology() {
  return (
    <>
      <Head>
        <title>{seoData.TECHNOLOGY_PARTNER.title}</title>
        <SeoMetaData data={seoData.TECHNOLOGY_PARTNER} />
      </Head>

      <TechnologyPartner />
    </>
  );
}
